<template>
    <section v-if="initialized" class="box-typical box-typical-dashboard panel panel-default scrollable">
        <header class="box-typical-header panel-heading">
            <a :href="'#'+endpoint" class="btn btn-rounded btn-secondary float-right btn-sm">View all</a>
            <h3 class="panel-title">{{ label }}</h3>
        </header>
        <div class="box-typical-body panel-body">
            <div v-if="_.isEmpty(itemData)" :class="['alert', 'alert-info', 'm-0']">
                {{ emptyText || 'No record' }}
            </div>
            <table v-else class="table table-dashboard">
                <thead>
                    <tr>
                        <th v-for="field in fields" :key="field.name">
                            <div class="pl-1">{{ field.label }}</div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-on:click="gotoItem(item.id)" v-for="item in itemData" :key="item.id" class="clickable">
                        <td v-for="key in _.keys(fields)" :key="key" v-html="_.get(item, key, '')"></td>
                    </tr>
                </tbody>
            </table>
        </div><!--.box-typical-body-->
    </section>
</template>
<script>
import Vuex from 'vuex';

let cache = {};

export default {
    data() {
        return {
            initialized: false,
            items: [],
        }
    },

    props: ['label', 'endpoint', 'filter', 'sort', 'limit', 'fields', 'emptyText'],

    mounted() {
        this.initialized = false;
        /*
        const localData = cache;
        this.items = _.get(localData, 'items', []);

        if (!_.isEmpty(this.items)) {
            this.initialized = true;
        }
        */

        const filter = _.toPairs(this.filter)
            .reduce((tmp, [key, value]) => `${tmp};${key}:${value}`, '');
        const sort = _.toPairs(this.sort)
            .reduce((tmp, [key, value]) => `${tmp};${key}:${value}`, '');
        const per_page = this.limit || 10;

        this.helpers('api').getData(this.endpoint, { filter, sort, per_page })
            .then(res => {
                this.items = res.data;
                this.initialized = true;
            })
            .catch(() => this.initialized = false)
    },

    destroyed() {
        // cache = { items: this.items };
        this.initialized = false;
    },

    computed: {
        cacheKey() {
            return this.$options.name + '/' + this.endpoint;
        },

        itemData() {
            return _.chain(this.items)
                .map(item => {
                    return {
                        id: item.id, type: item.type,
                        ...this.formatItemData(item.attributes),
                        ...this.formatItemData(item.meta),
                    }
                })
                .value();
        }
    },

    methods: {
        ...Vuex.mapActions(['changeUrl']),

        formatItemData(attributes) {
            const keys = _.keys(this.fields);
            const simplyReturn = (val) => val;

            return _.chain(attributes)
                .toPairs()
                .reduce((tmp, [key, rawValue]) => {
                    if (keys.indexOf(key) < 0) {
                        return tmp;
                    }

                    const handler = _.get(this.fields, [key, 'value'], simplyReturn);
                    return { ...tmp, [key]: handler(rawValue, attributes, this.__, this._) }
                }, {})
                .value();
        },

        gotoItem(id) {
            const item = this.items.find(it => it.id == id);
            const uriFormat = this.helpers('uriFormat');
            const link = _.get(item, 'links.self');

            if (!link) return;
            this.changeUrl(uriFormat(link));
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/dashboard-elements/TablePanelComponent.vue